import {Search} from 'lucide-react';
import {Input} from '@/shared/ui/input';
import {cn} from '@/lib/utils';

interface TableSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  containerClassName?: string;
  inputClassName?: string;
}

const TableSearchInput = ({
  value,
  onChange,
  placeholder = 'Search...',
  containerClassName,
  inputClassName,
}: TableSearchInputProps) => (
  <div className={cn('relative flex-1 min-w-[240px] max-w-md', containerClassName)}>
    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
    <Input
      placeholder={placeholder}
      className={cn(
        'pl-9 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-border focus:ring-offset-2 focus:border-input',
        inputClassName,
      )}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

export default TableSearchInput;
